export default {
    baseStyle: () => ({
        '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
            width: '20px',
            height: '20px',
            marginRight: '0'
        },
        '.p-w-r .pr-snippet div': {
            fontSize: '14px',
            fontFamily: `'Source Sans Pro', sans-serif`,
            lineHeight: '14px'
        },
        '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-snippet-rating-decimal': {
            padding: '0 2px',
            border: 0,
            fontSize: '12px',
            fontFamily: 'lato',
            fontWeight: '800',
            lineHeight: '16px',
            color: 'textColor',
            display: 'block'
        },
        '.pr-no-reviews, .pr-category-snippet__total, .pr-snippet-rating-decimal': {
            display: 'none'
        },
        '.p-w-r .pr-snippet-stars, .p-w-r .pr-review-snapshot, .p-w-r .pr-read-review, .p-w-r .pr-review-display, .p-w-r pr-rd-no-reviews':
            {
                background: 'transparent'
            },
        '.p-w-r .pr-review-display': {background: 'transparent'},
        '.p-w-r a, .p-w-r .pr-read-review a, .p-w-r .pr-review-display a': {color: 'primaryColor'},
        '.p-w-r .pr-snippet .pr-category-snippet__total': {
            display: 'none'
        },
        '.p-w-r .pr-snippet .pr-rating-stars .pr-star-v4:not(:first-of-type)': {
            display: 'none'
        },
        '.p-w-r .pr-snippet .pr-snippet-stars-png': {
            display: 'flex',
            alignItems: 'center',
            mb: '8px'
        },
        '.p-w-r .pr-category-snippet': {
            margin: '0'
        }
    }),
    sizes: {
        md: {
            '.p-w-r .pr-snippet .pr-snippet-stars-png .pr-star-v4': {
                width: '12px',
                height: '12px'
            },
            '.p-w-r .pr-snippet div': {
                fontSize: '12px',
                lineHeight: '12px',
                fontFamily: `'Source Sans Pro', sans-serif`
            }
        }
    }
}
